import React, { useState, useEffect, useRef, useMemo} from "react";
import { Modal, Table, Spin, Typography, Row, Col } from "antd";
import { FileSearchOutlined } from "@ant-design/icons";
import { message } from "antd";
import http from "@/utils/http";
import api from "@/utils/api";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
import commonFn from "@/utils/commonFn";

//  dataIndex 
const checkBreakdownColumns = [
   {
    title: "GL Acct",
    dataIndex: "glAcct",
    key: "glAcct",
    render: (text, r) => {
      if (!r?.glAcct && !r?.glAcctDescription) return "-";
      if (r?.glAcct && r?.glAcctDescription) {
        return `${r.glAcct} - ${r.glAcctDescription}`;
      }
      return r?.glAcct || r?.glAcctDescription;
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
     render: (v) => {
            return commonFn.amountToDollarBracketFn(v);
          },
  },
];

const columnStyle = {
  border: "1px solid #f0f0f0",
  padding: 20,
  borderRadius: 8,
  background: "#fafafa",
  minHeight: "100%",
};


const CheckNoDetailModal = ({ open, onCancel, record }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [filePaths, setFilePaths] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(true); 
  const uploadRef = useRef(null);

  useEffect(() => {
    if (!open || !record) return;

    let ignore = false;

    const fetchDetail = async () => {
      setDetail(null);
      setFilePaths([]);
      setLoading(true);
      try {
        const res = await http.get(api.getCheckNoDetail, {
          params: {
            seq: record.seq,
            vendorPaymentId: record.vendorPaymentId,
          },
        });
        if (ignore) return;

        if (res?.code === "1") {
          const data = res.data || {};
          setDetail(data);

          const copyFile = data.checkCopyFile;
          const files = copyFile?.url
            ? [
                {
                  uid: "checkCopy",
                  name: copyFile.fileName,
                  fileName: copyFile.fileName,
                  url: copyFile.url,
                  allPath: copyFile.url,
                  status: "done",
                },
              ]
            : [];

          setFilePaths(files);
          setTimeout(() => {
            uploadRef.current?.initUpdateList(files);
          }, 0);
        } else {
          message.error(res?.msg || "Failed to load check detail.");
        }
      } catch (err) {
        if (!ignore) message.error(err?.message || "Failed to load check detail.");
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchDetail();

    return () => {
      ignore = true;
    };
  }, [open, record]);

  return (
    <Modal
      title={
        <Row justify="start" align="middle" className="model_title">
          <Col>
            <FileSearchOutlined className="model_title_mr10" />
          </Col>
          <Col>
            <Typography.Title level={4} className="mg">
              CHECK NUMBER DETAIL
            </Typography.Title>
          </Col>
        </Row>
      }
      width="65%"
      style={{
        maxHeight: "70vh",
      }}
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}
    >
      <Spin spinning={loading}>
        <Row>
          <div className="model_top" style={{ width: "100%" }}>
            <Row gutter={24} style={{ width: "100%", margin: 0 }}>
              {/* 左侧：Check Detail */}
              <Col span={7}>
                <div style={columnStyle}>
                  <div className="modal-section-title">
                    Check Detail
                  </div>

                  <div style={{ marginBottom: 12 }}>
                    Module: {detail?.module ?? "-"}
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    Cashed Status: {detail?.cashedStatus ? "Cashed" : "Not Cashed"}
                  </div>
                  {detail?.clearedDate ? (
                    <div style={{ marginBottom: 12 }}>
                      Cleared Date: {detail.clearedDate}
                    </div>
                  ) : null}
                  <div style={{ marginBottom: 12 }}>
                    Check #: {detail?.checkNo ?? "-"}
                  </div>
                  {/* <div style={{ marginBottom: 12 }}>
                    Total: {detail?.totalAmount ?? "-"}
                  </div> */}
                  <div style={{ marginBottom: 12 }}>
                   Total: {detail?.totalAmount != null ? commonFn.amountToDollarBracketFn(detail.totalAmount) : "-"}
                  </div>
                  <div style={{ marginTop: 20, marginBottom: 8, fontWeight: 600 }}>
                    Total Break Down:
                  </div>
                  <Table
                    size="small"
                    pagination={false}
                    bordered
                    columns={checkBreakdownColumns}
                    dataSource={detail?.checkNoDetailListVoList || []}
                    rowKey={(r, i) => `${r.glAcct}-${i}`}
                  />
                </div>
              </Col>

              {/* 右侧：Check Copy */}
              <Col flex="17">
                <div style={columnStyle}>
                  <div
                    style={{
                      marginBottom: "16px",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Check Copy
                  </div>
                  <div style={{ marginTop: "20px", display: "flex", gap: 16 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <CustomUploadNewBank
                        ref={uploadRef}
                        customConfig={{
                          pdfHeight: "50vh",
                          fileFullName: "name",
                          notMultiple: true,
                          noUploadBtn: true,
                          noDeleteBtn: true,
                          disabled: true,
                        }}
                        setFilePaths={setFilePaths}
                        filePaths={filePaths}
                        setBtnDisabled={setBtnDisabled}
                        btnDisabled={btnDisabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Row>
      </Spin>
    </Modal>
  );
};

export default CheckNoDetailModal;